{
  "US_STATES": [
    { "name": "Alabama", "tz": "America/Chicago", "abbrev": "CT" },
    { "name": "Alaska", "tz": "America/Anchorage", "abbrev": "AKT" },
    { "name": "Arizona", "tz": "America/Phoenix", "abbrev": "MT" },
    { "name": "Arkansas", "tz": "America/Chicago", "abbrev": "CT" },
    { "name": "California", "tz": "America/Los_Angeles", "abbrev": "PT" },
    { "name": "Colorado", "tz": "America/Denver", "abbrev": "MT" },
    { "name": "Connecticut", "tz": "America/New_York", "abbrev": "ET" },
    { "name": "Delaware", "tz": "America/New_York", "abbrev": "ET" },
    { "name": "Florida", "tz": "America/New_York", "abbrev": "ET" },
    { "name": "Georgia", "tz": "America/New_York", "abbrev": "ET" },
    { "name": "Hawaii", "tz": "America/Honolulu", "abbrev": "HST" },
    { "name": "Idaho", "tz": "America/Denver", "abbrev": "MT" },
    { "name": "Illinois", "tz": "America/Chicago", "abbrev": "CT" },
    { "name": "Indiana", "tz": "America/Indiana/Indianapolis", "abbrev": "ET" },
    { "name": "Iowa", "tz": "America/Chicago", "abbrev": "CT" },
    { "name": "Kansas", "tz": "America/Chicago", "abbrev": "CT" },
    { "name": "Kentucky", "tz": "America/New_York", "abbrev": "ET" },
    { "name": "Louisiana", "tz": "America/Chicago", "abbrev": "CT" },
    { "name": "Maine", "tz": "America/New_York", "abbrev": "ET" },
    { "name": "Maryland", "tz": "America/New_York", "abbrev": "ET" },
    { "name": "Massachusetts", "tz": "America/New_York", "abbrev": "ET" },
    { "name": "Michigan", "tz": "America/Detroit", "abbrev": "ET" },
    { "name": "Minnesota", "tz": "America/Chicago", "abbrev": "CT" },
    { "name": "Mississippi", "tz": "America/Chicago", "abbrev": "CT" },
    { "name": "Missouri", "tz": "America/Chicago", "abbrev": "CT" },
    { "name": "Montana", "tz": "America/Denver", "abbrev": "MT" },
    { "name": "Nebraska", "tz": "America/Chicago", "abbrev": "CT" },
    { "name": "Nevada", "tz": "America/Los_Angeles", "abbrev": "PT" },
    { "name": "New Hampshire", "tz": "America/New_York", "abbrev": "ET" },
    { "name": "New Jersey", "tz": "America/New_York", "abbrev": "ET" },
    { "name": "New Mexico", "tz": "America/Denver", "abbrev": "MT" },
    { "name": "New York", "tz": "America/New_York", "abbrev": "ET" },
    { "name": "North Carolina", "tz": "America/New_York", "abbrev": "ET" },
    { "name": "North Dakota", "tz": "America/Chicago", "abbrev": "CT" },
    { "name": "Ohio", "tz": "America/New_York", "abbrev": "ET" },
    { "name": "Oklahoma", "tz": "America/Chicago", "abbrev": "CT" },
    { "name": "Oregon", "tz": "America/Los_Angeles", "abbrev": "PT" },
    { "name": "Pennsylvania", "tz": "America/New_York", "abbrev": "ET" },
    { "name": "Rhode Island", "tz": "America/New_York", "abbrev": "ET" },
    { "name": "South Carolina", "tz": "America/New_York", "abbrev": "ET" },
    { "name": "South Dakota", "tz": "America/Chicago", "abbrev": "CT" },
    { "name": "Tennessee", "tz": "America/Chicago", "abbrev": "CT" },
    { "name": "Texas", "tz": "America/Chicago", "abbrev": "CT" },
    { "name": "Utah", "tz": "America/Denver", "abbrev": "MT" },
    { "name": "Vermont", "tz": "America/New_York", "abbrev": "ET" },
    { "name": "Virginia", "tz": "America/New_York", "abbrev": "ET" },
    { "name": "Washington", "tz": "America/Los_Angeles", "abbrev": "PT" },
    { "name": "West Virginia", "tz": "America/New_York", "abbrev": "ET" },
    { "name": "Wisconsin", "tz": "America/Chicago", "abbrev": "CT" },
    { "name": "Wyoming", "tz": "America/Denver", "abbrev": "MT" }
  ],
  "COUNTRIES": [
    { "name": "Argentina", "tz": "America/Argentina/Buenos_Aires", "abbrev": "ART" },
    { "name": "Australia (Melbourne)", "tz": "Australia/Melbourne", "abbrev": "AEST/AEDT" },
    { "name": "Australia (Sydney)", "tz": "Australia/Sydney", "abbrev": "AEST/AEDT" },
    { "name": "Brazil (São Paulo)", "tz": "America/Sao_Paulo", "abbrev": "BRT" },
    { "name": "Canada (Toronto)", "tz": "America/Toronto", "abbrev": "ET" },
    { "name": "Canada (Vancouver)", "tz": "America/Vancouver", "abbrev": "PT" },
    { "name": "China", "tz": "Asia/Shanghai", "abbrev": "CST" },
    { "name": "Egypt", "tz": "Africa/Cairo", "abbrev": "EET" },
    { "name": "France", "tz": "Europe/Paris", "abbrev": "CET/CEST" },
    { "name": "Germany", "tz": "Europe/Berlin", "abbrev": "CET/CEST" },
    { "name": "India", "tz": "Asia/Kolkata", "abbrev": "IST" },
    { "name": "Indonesia", "tz": "Asia/Jakarta", "abbrev": "WIB" },
    { "name": "Israel", "tz": "Asia/Jerusalem", "abbrev": "IST" },
    { "name": "Italy", "tz": "Europe/Rome", "abbrev": "CET/CEST" },
    { "name": "Japan", "tz": "Asia/Tokyo", "abbrev": "JST" },
    { "name": "Malaysia", "tz": "Asia/Kuala_Lumpur", "abbrev": "MYT" },
    { "name": "Mexico (Mexico City)", "tz": "America/Mexico_City", "abbrev": "CST" },
    { "name": "New Zealand", "tz": "Pacific/Auckland", "abbrev": "NZST/NZDT" },
    { "name": "Philippines", "tz": "Asia/Manila", "abbrev": "PHT" },
    { "name": "Russia (Moscow)", "tz": "Europe/Moscow", "abbrev": "MSK" },
    { "name": "Saudi Arabia", "tz": "Asia/Riyadh", "abbrev": "AST" },
    { "name": "Singapore", "tz": "Asia/Singapore", "abbrev": "SGT" },
    { "name": "South Africa", "tz": "Africa/Johannesburg", "abbrev": "SAST" },
    { "name": "South Korea", "tz": "Asia/Seoul", "abbrev": "KST" },
    { "name": "Spain", "tz": "Europe/Madrid", "abbrev": "CET/CEST" },
    { "name": "Thailand", "tz": "Asia/Bangkok", "abbrev": "ICT" },
    { "name": "Turkey", "tz": "Europe/Istanbul", "abbrev": "TRT" },
    { "name": "United Arab Emirates", "tz": "Asia/Dubai", "abbrev": "GST" },
    { "name": "United Kingdom", "tz": "Europe/London", "abbrev": "GMT/BST" },
    { "name": "Vietnam", "tz": "Asia/Ho_Chi_Minh", "abbrev": "ICT" }
  ]
}
